import { Dispatch, SetStateAction, useMemo } from "react";
import { Box } from "@mui/material";
import { fitSvgToContainer } from "src/pages/PlannerPage/DeviceView/svgIconUtils";

type Icon = { id: number; icon_svg: string; color: string };

type IconWithLiveColorProps = {
    icon: Icon;
    iconColor: string;
    setIconColor: Dispatch<SetStateAction<string>>;
};

function colorizeSvg(svg: string, color: string): string {
    const doc = new DOMParser().parseFromString(svg, 'image/svg+xml');
    doc.querySelectorAll('path, rect, circle, ellipse, polygon, polyline').forEach(el => {
        el.setAttribute('fill', color);
    });
    return doc.documentElement.outerHTML;
}

export function IconWithLiveColor({ icon, iconColor, setIconColor }: IconWithLiveColorProps) {
    const html = useMemo(
        () => colorizeSvg(fitSvgToContainer(icon.icon_svg), iconColor),
        [icon.icon_svg, iconColor],
    );

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <div
                style={{ height: 30, width: 30 }}
                dangerouslySetInnerHTML={{ __html: html }}
            />
            <input
                type="color"
                value={iconColor}
                onChange={(e) => setIconColor(e.target.value)}
                style={{ width: 28, height: 36, cursor: 'pointer', border: 'none', background: 'transparent' }}
            />
        </Box>
    );
}
